import processingApplicationQuestionnaireService from "./processingApplicationQuestionnaireService";

const questionnaireService = [
    ...processingApplicationQuestionnaireService
]

export default questionnaireService;